import React, {useState} from 'react';
import { Typography, Modal, Button, ConfigProvider} from 'antd';
import styles from './ShoolAdminTip.module.css';

const {Title} = Typography;
const AddAccountForm = (props) => {
    
    const closeCommon = () => {
        props.closeCommonModal()
    };

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#1890FF',
                },
                components: {
                    Modal: {
                        titleFontSize: 18,
                    },
                },
            }}
        >
            <Modal
                maskClosable={false}
                // visible={true}
                open={props.openStatus}
                onCancel={closeCommon}
                footer={null} // 设置 footer 为 null 移除默认按钮
                width={600}
                title={"【系统权限优化通知】"}
            >
                <div style={{margin:20,fontSize:16}}>
                    <p>
                        为保障学校管理员权限规范，提升管理效率与数据安全，系统已优化权限展示：
                    </p>
                    <p>
                        1. 当前账号仅保留「用户管理」核心功能，其他菜单暂时隐藏
                    </p>
                    <p>
                        2. 若需使用原AI应用中心等功能，可通过「用户管理」模块创建新的子账号
                    </p>
                </div>
                <div style={{display:'flex',justifyContent:'center',width:'100%'}}>
                    <Button type="primary" onClick={closeCommon}>确认并不再弹出</Button>
                </div>
                
            </Modal>
        </ConfigProvider>
    );
};

export default AddAccountForm;
